import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=78a3acc0"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=78a3acc0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a3acc0')) {
      api.createRecord('78a3acc0', component.options)
    } else {
      api.reload('78a3acc0', component.options)
    }
    module.hot.accept("./productInfo.vue?vue&type=template&id=78a3acc0", function () {
      api.rerender('78a3acc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/product/productInfo.vue"
export default component.exports